export const poe = [
  { value: "enable", label: "Enable" },
  { value: "disable", label: "Disable" },
];

export const poeProfile = [
  { value: true, label: "Enable" },
  { value: false, label: "Disable" },
];

export const poeBulk = [
  { value: null, label: "-- mixed --" },
  { value: "enable", label: "Enable" },
  { value: "disable", label: "Disable" },
];
